<template>
    <!-- Start Page Banner -->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>News Media</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>Publication</li>
                    <li>News Media</li>
                </ul>
            </div>
        </div>
    </div>
    <!-- End Page Banner -->

    <!-- Start Media Area -->
    <div class="alumni-area pt-100 pb-70">
        <div class="container">
            <div class="section-title">
                <h2>Campus Chronicle</h2>
                <p>Capturing the Essence of College Life</p>
            </div>
            <div style="text-align: center;">
                <div class="thumbnails" v-for="(publication, index) in publications" :key="index">
                    <img style="width:250px;height:250px;border:solid 1px lightgray;padding:5px;cursor:pointer;"
                        :src="publication.thumbnail_path" @click="openLightbox(index)" />
                </div>
            </div>
        </div>
    </div>
    <!-- End Media Area -->

    <!-- Lightbox Modal -->
    <div v-if="showLightbox" class="lightbox-overlay" @click="closeLightbox">
        <div class="lightbox-content" @click.stop>
            <span class="lightbox-close" @click="closeLightbox">&times;</span>
            <img :src="publications[currentImageIndex].image_path" class="lightbox-image" />
        </div>
    </div>
</template>


<script>
export default {
    name: "MediaView",
    data() {
        return {
            publications: [],
            showLightbox: false,
            currentImageIndex: 0,
        };
    },
    methods: {
        async fetchData() {
            const response = await fetch("json/newsmedia.json");
            this.publications = await response.json();
        },
        openLightbox(index) {
            this.currentImageIndex = index;
            this.showLightbox = true;
        },
        closeLightbox() {
            this.showLightbox = false;
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style scoped>
.thumbnails {
    display: inline;
    flex-wrap: wrap;
}

.thumbnails img {
    width: 100px;
    height: auto;
    margin: 5px;
    cursor: pointer;
}

.lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.lightbox-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    overflow: auto; /* Enable scroll if content exceeds */
    background: white; /* Optional: to provide a contrast background */
    border-radius: 8px;
    padding: 10px;
}

.lightbox-image {
    width: 100%; /* Ensures responsiveness */
    height: auto;
    display: block;
}

.lightbox-close {
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 30px;
    color: white;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    padding: 5px 10px;
}
</style>
